module.exports = __webpack_public_path__ + "static/img/logo2.517827c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo2.jpg
// module id = axC4
// module chunks = 1